
import React, { useState, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  Button,
  Box,
  Typography,
  TextField,
  Tooltip,
} from '@mui/material';
import closeIcon from '../../assests/images/close-circle.svg';
import Plus from '../../assests/images/Plus.svg';
import EditIcon from '../../assests/images/edit-2.svg';
import CohortIcon from '../../assests/images/cohort-icon.svg';
import CreateCohortFilter from './CreateCohortFilter';
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from '../../utils/utils';
import { createcohorts } from "../../pages/assign-task/api";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import { SxProps, Theme } from '@mui/material';
import { AxiosError, AxiosResponse } from 'axios';
export interface Filters {
  outletTypes: { [key: string]: boolean };
  locations: { [key: string]: boolean };
  region: { [key: string]: boolean };
  taskHistory: { [key: string]: boolean };
  taskType: { [key: string]: boolean };
  status: { [key: string]: boolean };
  Contract_since: { [key: string]: boolean };
  Current_rental_value: { [key: string]: boolean };
  taskNames: { [key: string]: boolean };
  asmNames: { [key: string]: boolean };
  territoryCodes: { [key: string]: boolean };
  [key: string]: { [key: string]: boolean };
}

interface CreateCohortProps {
  buttonText: string;
  buttonVariant: 'contained' | 'outlined';
  buttonIcon?: string;
  type?: 'default' | 'edit';
  sx?: SxProps<Theme>;
  cohorttype: string
}

const CreateCohort: React.FC<CreateCohortProps> = ({
  buttonText,
  buttonVariant,
  buttonIcon,
  type = 'default',
  sx,
  cohorttype

}) => {
  const [open, setOpen] = useState(false);
  const [cohortName, setCohortName] = useState('');
  const { showAlert } = useAlert();
  const token = getToken();
  const navigate = useNavigate();
  const { id } = useParams();

  // Initialize filters with all options set to false
  const [filters, setFilters] = useState<Filters>({
    outletTypes: {
      // Paid: false,

      // Unpaid: false,
    },
    locations: {
      // Mumbai: false,
      // Delhincr: false,
    },
    region: {
      // South: false,
      // East: false,
      // Sue: false,
    },
    taskHistory: { recent: false, older: false },
    taskType: { urgent: false, normal: false },
    status: {
      Active: false,
      Inactive: false,
    },
    Contract_since: {
      // Last1Year: false,
      // Last3Year: false,
      // Last6Year: false,
    },
    Current_rental_value: {
      // "0-2000": false,
      // "2000-40000": false,
      // "4000-50000": false,
    },
    taskNames: {}, // Will be populated by outlet_names from API
    asmNames: {},
    territoryCodes: {},
  });

  const handleOpen = () => {
    setOpen(true);
  };
  console.log(cohorttype, "cohorttypeeeeeee");
  const handleClose = () => {
    setOpen(false);
    setCohortName('');
  };

  const handleCohortNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCohortName(event.target.value);
  };
  console.log(filters, "filtersoooooooooo")
  const selectedLocations = Object.entries(filters.locations)
    .filter(([key, value]) => value && key.toLowerCase() !== 'all')
    .map(([key]) => key);

  const selectedOutletTypes = Object.entries(filters.outletTypes)
    .filter(([key, value]) => value && key.toLowerCase() !== 'alltypes')
    .map(([key]) => key);

  const selectedRegions = Object.entries(filters.region)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedStatus = Object.entries(filters.status)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedContractSince = Object.entries(filters.Contract_since)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedCurrentRentalValue = Object.entries(filters.Current_rental_value)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedTaskNames = Object.entries(filters.taskNames)
    .filter(([key, value]) => value)
    .map(([key]) => key); // Match outlet_names casing

  const selectedAsmNames = Object.entries(filters.asmNames)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const selectedTerritoryCodes = Object.entries(filters.territoryCodes)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const handleSave = async () => {
    showAlert('Saving cohort...', 'info');
    const reqBody = {
      locations: selectedLocations,
      outlet_type: selectedOutletTypes,
      region: selectedRegions,
      status: selectedStatus,
      Contract_since: selectedContractSince,
      Current_rental_value: selectedCurrentRentalValue,
      task_names: selectedTaskNames,
      asm_names: selectedAsmNames,
      territory_codes: selectedTerritoryCodes,
      outlet_names: selectedTaskNames, // Map taskNames to outlet_names
      cohortName,
      task_id: id || 'undefined',
      cohort_type: cohorttype
    };

    try {
      const response = await createcohorts(reqBody, token);
      if (response) {
        showAlert('Cohort created successfully!', 'success');
        setOpen(false);
        // navigate(`/cohorts-view`);
        // setTimeout(() => window.location.reload(), 100);


      }
    } catch (error) {
      // Handle AxiosError specifically
      if (error instanceof AxiosError && error.response?.data?.message) {
        console.error('Error saving cohort:', error.response.data);
        showAlert(error.response.data.message, 'error');
      } else if (error instanceof Error) {
        console.error('Error saving cohort:', error);
        showAlert(error.message || 'An error occurred while saving the cohort.', 'error');
      } else {
        console.error('Unknown error saving cohort:', error);
        showAlert('An unexpected error occurred.', 'error');
      }
    }
  };
  const isSaveEnabled = useMemo(() => {
    const hasCohortName = cohortName && cohortName.trim() !== "";

    // Check if any filter group has at least one `true`
    const hasFilters =
      Object.values(filters.locations || {}).some(Boolean) ||
      Object.values(filters.region || {}).some(Boolean) ||
      Object.values(filters.taskNames || {}).some(Boolean) ||
      Object.values(filters.territoryCodes || {}).some(Boolean) ||
      Object.values(filters.asmNames || {}).some(Boolean) ||
      Object.values(filters.outletTypes || {}).some(Boolean) ||
      Object.values(filters.status || {}).some(Boolean) ||
      Object.values(filters.Contract_since || {}).some(Boolean) ||
      Object.values(filters.Current_rental_value || {}).some(Boolean);

    return hasCohortName && hasFilters;
  }, [filters]);

  console.log(filters, "filterskkkkkkkkkk")
  return (
    <div>
      <Tooltip title={buttonText === 'Edit' ? 'Edit' : 'Create a new cohort'} arrow>
        <Button
          variant={buttonVariant}
          color="primary"
          onClick={handleOpen}
          sx={{
            borderRadius: '8px',
            padding: '14px 16px',
            color: buttonText === 'Edit' || buttonVariant === 'contained' ? '#FFF' : 'rgba(200, 23, 47, 1)',
            textDecoration: 'none',
            background: buttonVariant === 'contained' ? 'rgba(200, 23, 47, 1)' : '#fff',
            textAlign: 'center',
            fontWeight: '500',
            textTransform: 'none',
            width: buttonText === 'Edit' ? '10px' : '150px',
            boxShadow: 'none',
            border: buttonText === 'Edit' || buttonVariant === 'contained' ? 'none' : '1px solid rgba(200, 23, 47, 1)',
            '&:hover': {
              boxShadow: 'none',

            },
            ...sx,
          }}
        >
          <img src={buttonText === 'Edit' ? EditIcon : Plus} alt="button-icon" />
          <Typography sx={{ fontSize: '14px', paddingLeft: '10px' }}>
            {buttonText}
          </Typography>
        </Button>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          borderRadius: '10px',
          '& .MuiPaper-elevation': { borderRadius: '10px' },
          '& .MuiPaper-root': {
            borderRadius: '10px',   // Dialog corner radius
            width: '450px',
            maxHeight: '600px',
            "@media (max-width: 1366px)": {
              maxHeight: '450px',
            }

          },

        }}
      >
        <Box sx={{
          overflowY: 'overlay',
          width: "450px"

        }}>
          <DialogTitle sx={{ padding: '0', }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #c4c4c4',
                paddingBottom: '10px',
                // position: 'fixed',
                width: '435px',
                top: '3rem',
                background: '#fff',
                zIndex: 9,
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px',
                overflow: "hidden"
              }}
            >
              <Typography
                sx={{
                  marginLeft: '0px',
                  marginTop: '20px',
                  fontSize: '24px',
                  fontWeight: '600',
                  padding: '0 20px',
                  display: 'flex',
                }}
              >
                <img
                  src={CohortIcon}
                  alt="CohortIcon"
                  style={{ position: 'relative', top: '-5px', marginRight: '10px' }}
                />
                {cohorttype === "Static Cohort" ? " Static Create Cohort" : "Dynamic Create Cohort"}
              </Typography>
              <Tooltip title="Close the Create Cohort" arrow>
                <Button
                  onClick={handleClose}
                  color="primary"
                  sx={{
                    borderRadius: '50%',
                    color: '#000',
                    fontSize: '10px',
                    position: 'relative',
                    right: '-10px',
                    '&:hover': {
                      background: 'none',
                    },
                  }}
                >
                  <img src={closeIcon} alt="close" width="15px" />
                </Button>
              </Tooltip>
            </Box>

            <Box
              sx={{
                padding: '0 20px',
                //marginTop: '4rem',
                position: 'relative',
                //bottom: -19,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  mt: 2,
                  color: '#282829',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                Cohort Name
                <Box component="span" sx={{ color: 'red' }}>
                  *
                </Box>
              </Typography>
              <TextField
                placeholder="Enter Cohort name"
                sx={{ border: '1px solid #E7E8E9', borderRadius: '10px' }}
                name="Name"
                fullWidth
                margin="normal"
                required
                value={cohortName}
                onChange={handleCohortNameChange}
              />

              <Typography
                variant="subtitle2"
                sx={{
                  mt: 2,
                  color: '#282829',
                  fontSize: '16px',
                  fontWeight: '600',
                  paddingBottom: "9px"
                }}
              >
                Apply Filter
                <Box component="span" sx={{ color: 'red' }}>
                  *
                </Box>

              </Typography>
              <Box sx={{ paddingBottom: "20px" }}>
                <CreateCohortFilter
                  buttonText={buttonText}
                  filters={filters}
                  setFilters={setFilters}
                  token={token}
                />
              </Box>
              <Box
                sx={{
                  marginTop: '0px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Tooltip title="Cancel" arrow>
                  <Button
                    onClick={handleClose}
                    sx={{
                      border: '1px solid #7D7E7F',
                      color: '#7D7E7F',
                      textTransform: 'capitalize',
                      background: '#FFF',
                      marginLeft: '20px',
                      padding: '8px 20px',
                      borderRadius: '10px',
                      marginBottom: '20px',
                      height: "42px",
                    }}
                  >
                    Cancel
                  </Button>
                </Tooltip>
                <Tooltip title="Save and proceed" arrow>
                  <Button
                    onClick={handleSave}
                    sx={{
                      border: '1px solid #7D7E7F',
                      color: isSaveEnabled ? '#FFF' : '#7D7E7F',
                      textTransform: 'capitalize',
                      background: isSaveEnabled ? '#C8172F' : '#FFF',
                      marginLeft: '20px',
                      padding: '8px 20px',
                      borderRadius: '10px',
                      height: "42px",
                      marginBottom: '20px',
                    }}
                    disabled={!isSaveEnabled}
                  >
                    Save
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </DialogTitle>
        </Box>
      </Dialog>
    </div >
  );
};

export default CreateCohort;
